/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/not rlike.json`.

import type { OperatorDefinition } from '../../definition_types';

/**
 * Use `RLIKE` to filter data based on string patterns using
 * regular expressions. `RLIKE` usually acts on a field placed on
 * the left-hand side of the operator, but it can also act on a constant (literal)
 * expression. The right-hand side of the operator represents the pattern, which can
 * be a string literal, a query parameter, or any constant expression such as a call
 * to `CONCAT` or `TO_UPPER`.
 */
const definition: OperatorDefinition = {
  operator: 'not rlike',
  name: 'not_rlike',
  signatures: [
    {
      params: [
        {
          name: 'str',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'pattern',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'str',
          type: 'text',
          optional: false,
        },
        {
          name: 'pattern',
          type: 'keyword',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
